let initialState = {
	ticketWidgetData: null,
	ticketLoader: { value: false, id: null },
};
const OrmWidget = (state = initialState, action) => {
	switch (action.type) {
		case "SET_TICKET_WIDGET_FETCH":
			return {
				...state,
				ticketWidgetData: action.payload,
			};

		case "SET_TICKET_LOADER":
			return {
				...state,
				ticketLoader: action.payload,
			};

		default:
			return state;
	}
};

export default OrmWidget;
